import '.gb{margin:auto 4px;}.ssr-plugin'
import '.gc{height:calc(100% - 8px );}.ssr-plugin'
import '.gd{width:1px;}.ssr-plugin'
import '.ge{z-index:0;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.gf{padding:2px 8px 2px 8px;}.ssr-plugin'
import '.gg{height:5px;}.ssr-plugin'
import '.s{height:1px;}.ssr-plugin'
import '.gh{width:2px;}.ssr-plugin'
import '.gi{height:2px;}.ssr-plugin'
import '.gj{margin:auto 8px;}.ssr-plugin'
import '.fi{display:inline-block;}.ssr-plugin'
import '.cf{border-radius:4px;}.ssr-plugin'
import { colors } from '../../tokens/colors.js'
import { Style, styled } from 'inlines'

type SeparatorProps = {
  orientation?: 'horizontal' | 'vertical'
  variant?: 'line' | 'dot'
  style?: Style
}

function Separator({
  orientation = 'horizontal',
  variant = 'line',
  style,
}: SeparatorProps) {
  if (variant === 'line') {
    if (orientation === 'vertical') {
      return (
        <styled.div className="gb gc gd ge"
          style={{
            background: colors.neutral10,
            ...style,
          }}
        />
      )
    }
    return (
      <styled.div className="h gf gg"
        style={{
          ...style,
        }}
      >
        <div className="s h"
          style={{ background: colors.neutral10 }}
        />
      </styled.div>
    )
  } else {
    return (
      <styled.div className="gh gi gj fi cf ge"
        style={{
          background: colors.neutral60,
          // margin:'auto 6px',
          ...style,
        }}
      />
    )
  }
}

export { Separator }
export type { SeparatorProps }
